import Features from '../components/Features';
import Hero from '../components/Hero';

const HomePage = () => {
	return (
		<div className='h-full'>
			<Hero />
			<Features />
		</div>
	);
};

export default HomePage;
